// app/javascript/projects/components/TextDropdown.jsx

import React, { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

// Descriptor-value combobox: type to filter existing choices, click (or type
// an exact match) to select, or create a new choice via the "Add:" row.
// Tier 3 widget (MUI Autocomplete); inputs styled to match ui-form-control.

const INPUT_SX = {
  '& .MuiOutlinedInput-root': {
    padding: '0 9px',
    minHeight: '34px',
    fontSize: '14px',
    backgroundColor: '#ffffff',
    borderRadius: '4px',
    '& fieldset': { borderColor: '#cccccc' },
    '&:hover fieldset': { borderColor: '#cccccc' },
    '&.Mui-focused fieldset': { borderColor: '#4A90E2', borderWidth: '1px' },
  },
  '& .MuiOutlinedInput-input': { padding: '6px 3px' },
};

function TextDropdown({
  multi_choices,
  selected_multi_choice,
  createSelectionCallback,
  addAndSelectChoiceCallback,
}) {
  const selectedText = selected_multi_choice ? selected_multi_choice.choice : '';
  const [inputValue, setInputValue] = useState(selectedText);

  useEffect(() => {
    setInputValue(selectedText);
  }, [selectedText]);

  const handleInputChange = (event, newText, reason) => {
    setInputValue(newText);
    if (reason !== 'input') return;

    // Parity with the old behavior: typing an exact choice name selects it.
    const exact = multi_choices.find((choice) => choice.choice === newText);
    if (exact) createSelectionCallback(exact.id);
  };

  const handleChange = (event, option) => {
    if (!option) return;
    if (option.addNew) {
      addAndSelectChoiceCallback(option.inputValue);
      return;
    }
    createSelectionCallback(option.id);
  };

  const filterOptions = (options, { inputValue: input }) => {
    const lower = input.toLowerCase();
    const filtered = options.filter((choice) => choice.choice.toLowerCase().includes(lower));
    const exactMatch = options.some((choice) => choice.choice === input);
    if (input.length > 0 && !exactMatch) {
      return [{ addNew: true, inputValue: input, choice: `Add: ${input}` }, ...filtered];
    }
    return filtered;
  };

  return (
    <Autocomplete
      className="descriptor-autocomplete"
      id="descriptor-dropdown"
      options={multi_choices}
      value={selected_multi_choice || null}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      onChange={handleChange}
      filterOptions={filterOptions}
      getOptionLabel={(option) => (typeof option === 'string' ? option : option.choice)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      disableClearable
      forcePopupIcon
      sx={INPUT_SX}
      slotProps={{ listbox: { style: { fontSize: 14 } } }}
      renderInput={(params) => <TextField {...params} size="small" />}
    />
  );
}

export default TextDropdown;
